import {SubmitHandler, useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDevice} from '@treatwell/ui';
import type {FormInputs} from '../Form';
import {register} from '../../../../../api/register';
import {fetchChannel} from '../../../../../api/rainbow';
import {getRegisterError} from './handleError';
import {
  getReferralCode,
  getSuccessRedirectPath,
} from './getSuccessRedirectPath';
import {trackMParticleRegister, trackRegisterSubmitted} from './tracking';

export const useSubmitButtonHandler = () => {
  const {t} = useTranslation();
  const {handleSubmit, setError, clearErrors} = useFormContext<FormInputs>();
  const {isMobile: isWebMobile} = useDevice();

  const onSubmitForm: SubmitHandler<FormInputs> = async (data) => {
    clearErrors('root.serverError');
    const referralCode = getReferralCode(window.location.search);
    const countryPromise = fetchChannel()
      .then((channel) => channel.country.countryCode)
      .catch(() => undefined);

    const trackRegisterSubmission = async (errorMessage?: string) => {
      const country = await countryPromise;
      if (!country) {
        return;
      }
      trackRegisterSubmitted({
        country,
        isMarketingOptedIn: data.marketingAllowed,
        isWebMobile,
        errorMessage,
      });
    };

    try {
      await register(data, referralCode);
      const country = await countryPromise;
      if (country) {
        await trackMParticleRegister(country, data.marketingAllowed);
      }
      trackRegisterSubmission();
      const redirectPath = getSuccessRedirectPath(
        window.location.search,
        window.location.pathname
      );
      window.location.href = redirectPath;
    } catch (error) {
      const err = error as Error;
      setError('root.serverError', getRegisterError(error, t));
      trackRegisterSubmission(err.message || JSON.stringify(error));
    }
  };

  return {
    handleSubmit: handleSubmit(onSubmitForm),
  };
};
